/**
 * Phase 6 Plan 02 — useUpdateCleaningSettings (CADENCE-6.1, D-141).
 *
 * PM-side mutation that PATCHes /api/admin/cleaning-settings. On success,
 * invalidates BOTH ASSETS_GEOJSON_KEY (network-wide map recolor — server-side
 * derive_all_colors reads the new cadence on the next GET, per Plan 01 D-141)
 * AND CLEANING_SETTINGS_KEY (settings page re-renders with server-canonical
 * values).
 *
 * Multi-key invalidation matches Plan 04-04 useInspectionEdit precedent.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError } from "../../api/client";
import { ASSETS_GEOJSON_KEY } from "../../api/assets";
import {
  CLEANING_SETTINGS_KEY,
  patchCleaningSettings,
  type CleaningSettingsPatchPayload,
  type CleaningSettingsUpdatedResponse,
} from "../../api/cleaningSettings";

export function useUpdateCleaningSettings() {
  const qc = useQueryClient();
  return useMutation<
    CleaningSettingsUpdatedResponse,
    ApiError,
    CleaningSettingsPatchPayload
  >({
    mutationFn: patchCleaningSettings,
    onSuccess: () => {
      // D-141 multi-key invalidate.
      qc.invalidateQueries({ queryKey: ASSETS_GEOJSON_KEY });
      qc.invalidateQueries({ queryKey: CLEANING_SETTINGS_KEY });
    },
  });
}
